// transform parent value prop (example: "roof.deck.bridge") into slugs array
export const parseMultiLevelsValue = (value = "") => value?.split(".") ?? [];

export const buildMultiLevelsValue = ({
  value = "",
  newSlugValue = "",
  newSlugLevel = 0,
}) => {
  const selectedSlugs = parseMultiLevelsValue(value);

  // select new value at the specific level (this resets sub-levels)
  const newSelections = selectedSlugs.slice(0, newSlugLevel);
  if (newSlugValue) {
    newSelections[newSlugLevel] = newSlugValue;
  }

  // rebuild the new value (example: "roof.beam")
  return newSelections.join(".");
};
